import * as React from 'react'

const SvgCliIcon = (props) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.3337 8H1.66699M11.667 15.0833L13.7503 13L11.667 10.9167M8.33366 10.9167L6.25033 13L8.33366 15.0833M1.66699 7L1.66699 14C1.66699 15.4001 1.66699 16.1002 1.93948 16.635C2.17916 17.1054 2.56161 17.4878 3.03202 17.7275C3.5668 18 4.26686 18 5.66699 18H14.3337C15.7338 18 16.4339 18 16.9686 17.7275C17.439 17.4878 17.8215 17.1054 18.0612 16.635C18.3337 16.1002 18.3337 15.4001 18.3337 14V7C18.3337 5.59987 18.3337 4.8998 18.0612 4.36502C17.8215 3.89462 17.439 3.51217 16.9686 3.27248C16.4339 3 15.7338 3 14.3337 3L5.66699 3C4.26686 3 3.5668 3 3.03202 3.27248C2.56161 3.51217 2.17916 3.89462 1.93948 4.36502C1.66699 4.8998 1.66699 5.59987 1.66699 7Z"
      stroke="white"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgCliIcon
